import { useHouseholds } from './useHousehold';
import { useSelectedHouseholdContext } from '../context/SelectedHouseholdContext';
import { useActiveMemberContext } from '../context/ActiveMemberContext';

export function useSelectedHousehold() {
  const { data: households, isLoading } = useHouseholds();
  const { selectedId, setSelectedId } = useSelectedHouseholdContext();
  const { activeMemberHouseholdId } = useActiveMemberContext();

  // While acting as a shared-device user, lock the whole app to that user's single
  // household — they belong to exactly one, so the household switcher and calendar
  // must not span the primary's other households.
  if (activeMemberHouseholdId) {
    const scoped = (households ?? []).filter((h) => h.householdId === activeMemberHouseholdId);
    return {
      householdId: activeMemberHouseholdId,
      selectedId: activeMemberHouseholdId,
      setSelectedId,
      households: scoped,
      isLoading,
    };
  }

  const householdId = selectedId || (households?.[0]?.householdId ?? '');
  return { householdId, selectedId, setSelectedId, households, isLoading };
}
